import React from 'react';
import ContentSection from './ContentSection';
import LeaderWisdomSection from './LeaderWisdomSection';
import PersonalWisdomSection from './PersonalWisdomSection';
import TestimonySection from './TestimonySection';
import EventSection from './EventSection';
import { PageSectionData } from '../../../types/configuration';
import {
  Button,
  Card,
  Container,
  Flex,
  Group,
  Stack,
  Text,
  Title
} from '@mantine/core';
import CaseStudySection from './CaseStudySection';
import TopicSection from './TopicSection';
import { IcnSwitch } from '../../../assets/icon';

interface SearchSectionProps {
  pageSection: PageSectionData[];
  isError?: boolean;
  loading?: boolean;
  querysearch?: string;
  isDetail?: boolean;
  isUmum?: boolean;
  onLoginClick?: () => void;
}

const SearchSection: React.FC<SearchSectionProps> = ({
  pageSection,
  querysearch,
  isDetail = false,
  isUmum = false,
  isError = false,
  loading = false,
  onLoginClick
}) => {
  const renderSection = (section: PageSectionData) => {
    switch (section.type) {
      case '001':
        return (
          <ContentSection
            isUmum={isUmum}
            isSearch={true}
            querysearch={querysearch}
            {...section}
            isButtonView={isDetail ? 'N' : 'Y'}
            data={pageSection.filter((section) => section.type === '001')}
          />
        );
      case '002':
        if (isUmum) return null;
        return (
          <LeaderWisdomSection
            isUmum={isUmum}
            isSearch={true}
            {...section}
            querysearch={querysearch}
            isButtonView={isDetail ? 'N' : 'Y'}
            data={pageSection.filter((section) => section.type === '002')}
          />
        );
      case '003':
        return (
          <PersonalWisdomSection
            isUmum={isUmum}
            {...section}
            querysearch={querysearch}
            isButtonView={isDetail ? 'N' : 'Y'}
            isSearch={true}
            data={pageSection.filter((section) => section.type === '003')}
          />
        );
      case '004':
        return (
          <TestimonySection
            isUmum={isUmum}
            isButtonView={isDetail ? 'N' : 'Y'}
            querysearch={querysearch}
            isSearch={true}
            isDetail={isDetail}
            {...section}
            data={pageSection.filter((section) => section.type === '004')}
          />
        );
      // case '006':
      //   return <EventSection {...section} courseName={querysearch} />;
      case '012':
        if (isUmum) return null;
        return (
          <CaseStudySection
            section={pageSection.filter((section) => section.type === '012')[0]}
            isSearch={true}
            isCarousel={true}
            querysearch={querysearch}
          />
        );

      case '011':
        if (isUmum) return null;
        return (
          <TopicSection
            section={pageSection.filter((section) => section.type === '011')[0]}
            isSearch={true}
            isCarousel={true}
            querysearch={querysearch}
          />
        );

      default:
        return null;
    }
  };

  return loading ? null : (
    <Stack gap={32}>
      {isDetail ? null : isUmum ? (
        <>
          <Text fz={20} fw={700}>
            Course Events
          </Text>
          <Container size={'lg'} w={'100%'} px={10}>
            <Card
              style={{
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                borderRadius: '10px',
                padding: '20px',
                textAlign: 'center',
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Text size="sm" style={{ marginBottom: '20px' }}>
                Please login to find more information and access available{' '}
                <b>courses</b>.
              </Text>
              <Button
                variant="light"
                color="orange"
                radius="xl"
                style={{
                  width: '100%'
                }}
                onClick={onLoginClick}
              >
                Login
              </Button>
            </Card>
          </Container>
        </>
      ) : (
        <EventSection isDetail={isDetail} courseName={querysearch} />
      )}
      <>
        {pageSection.map((section, i) => {
          return (
            <React.Fragment key={i}>{renderSection(section)}</React.Fragment>
          );
        })}
      </>
    </Stack>
  );
};

export default SearchSection;
